import * as log from '../log';
import ko from 'knockout';
import kx from '../knockout/extended';
import _ from 'lodash';
// import kendo from '../libs/kendo/kendo.drawing';

export interface IScreenshotable {
  onCapturingImageStarted?(): Promise<void>;
  onCapturingImageCompleted?(): Promise<void>;
  isCapturingImage?: kx.Observable<boolean>;
}

export class ImageRenderer {
  isProcessing = ko.observable(false);
  isCapturingImage = ko.observable(false);
  isSupported = ko.observable(true);
  areImagesSupported = ko.observable(true);
  bylineText = window.location.href;

  constructor() {
    // If screenshot failed once, hide images. This fixes Firefox, which cannot screenshot images more than once,
    // and IE10/9, which cannot screenshot images if CORS is required (unless the images are embedded as data URIs)
    this.areImagesSupported(true);

    if (!this.isKendoDrawDomSupported()) {
      this.isSupported(false);
      return;
    }
  }

  captureImage($widget: JQuery, onCompleted: (imageData: string) => JQueryPromise<any>) {
    this.isProcessing(true);
    this.isCapturingImage(true);

    const viewModels = _($widget.find('.screenshotable'))
      .map((element: HTMLElement) => ko.dataFor(element) as IScreenshotable)
      .reject(_.isNil)
      .value();

    // _.forEach(viewModels, viewModel => {
    //     if (ko.isObservable(viewModel.isCapturingImage) || ko.isWriteableObservable(viewModel.isCapturingImage)) viewModel.isCapturingImage(true);
    //     return true;
    // });

    // Force knockout to update UI before drawing
    ko.tasks.runEarly();

    // const onCapturingImageStartedPromises = _.map(viewModels, viewModel => {
    //     return viewModel.onCapturingImageStarted ? viewModel.onCapturingImageStarted() : Promise.resolve();
    // });
    throw new Error("image capturing doesn't work yet... needs to be fixed.");

    // return Promise.all(onCapturingImageStartedPromises)
    //     .then(() => {
    //         const draw = kendo.drawing;
    //         return draw
    //             .drawDOM($widget, null)
    //             .always(() => {
    //                 this.isCapturingImage(false);

    //                 const onCapturingImageCompletedPromises = _.map(viewModels, viewModel => {
    //                     return viewModel.onCapturingImageCompleted ? viewModel.onCapturingImageCompleted() : Promise.resolve();
    //                 });

    //                 return Promise.all(onCapturingImageCompletedPromises);
    //             })
    //             .then((root: kendo.drawing.Group) => draw.exportImage(root, null))
    //             .fail(error => {
    //                 const retry = this.areImagesSupported();
    //                 this.areImagesSupported(false);
    //                 if (retry) {
    //                     this.captureImage($widget, onCompleted);
    //                 }
    //             })
    //             .then((data: string) => onCompleted(data))
    //             .always(() => this.isProcessing(false));
    //     })
    //     .catch(error => {
    //         log.errorEx(error, 'ImageRenderer failed to capture screenshot');
    //         return Promise.reject(error);
    //     });
  }

  private isKendoDrawDomSupported() {
    return 'getComputedStyle' in window;
  }
}
